<template>
  <Container>
    <v-flex>
      <v-card v-if="!storyStore.isLoadStoryVideo">
        <v-toolbar dark>
          <v-btn icon fab color="white" small @click="onClickBack">
            <v-icon color="black">arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            storyStore.selectedStoryVideo.name
          }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row grid-list-md>
            <v-flex mr-2 xs3>
              <v-card>
                <v-toolbar dark>
                  <v-toolbar-title>Level Detail</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="onClickUpdateLevel" color="green">
                    <v-icon>save</v-icon>Save
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container grid-list-xs text-xs-center>
                    <v-layout column>
                      <v-flex>
                        <v-checkbox
                          label="Available for Free User"
                          v-model="
                            storyStore.selectedStoryVideo.isGuestPlayable
                          "
                          :value="storyStore.selectedStoryVideo.isGuestPlayable"
                          v-on:change="e => onChangeLevel('isGuestPlayable', e)"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Name"
                          :value="storyStore.selectedStoryVideo.name"
                          @change="value => onChangeLevel('name', value)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex mt-3>
                            <v-btn
                              dark
                              color="black"
                              v-on:click="
                                isEditImage = true;
                                isEditLevel = true;
                              "
                            >
                              <v-icon>edit</v-icon>EDIT IMAGE
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-img
                          :src="
                            storyStore.updateLevel.img_uri ||
                            storyStore.selectedStoryVideo.img_uri
                          "
                          v-lazy="
                            storyStore.updateLevel.img_uri ||
                            storyStore.selectedStoryVideo.img_uri
                          "
                          class="content_img"
                        ></v-img>
                      </v-flex>
                      <v-card-actions>
                        <v-btn color="red" dark @click="onClickDeleteLevel">
                          <v-icon>delete</v-icon>Delete this level
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex mr-2 xs2>
              <v-card>
                <v-toolbar dark>
                  <v-toolbar-title>Activities</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    color="green"
                    @click="
                      onClickCreateActivity();
                      selectedActivityIndex = -1;
                    "
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-list>
                  <draggable @end="order">
                    <v-list-tile
                      v-for="(activity, index) in storyStore.selectedStoryVideo
                        .activities"
                      :key="activity._id"
                      @click="onSelectActivity(index, activity._id)"
                      :class="
                        index === selectedActivityIndex ? 'active' : 'inactive'
                      "
                    >
                      <v-list-tile-content>
                        <v-list-tile-title
                          >{{ index + 1 }}
                          {{ activity.title }}</v-list-tile-title
                        >
                        <v-list-tile-sub-title
                          >Game type :
                          {{
                            activity.game_data[0].game_type
                          }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                    </v-list-tile>
                  </draggable>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex mr-2 v-if="selectedActivityIndex != -1">
              <v-card dark>
                <v-toolbar>
                  <v-toolbar-title>Activity Detail</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn @click="onUpdateActivity" color="green">
                    <v-icon>save</v-icon>Save
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-container>
                    <v-layout column>
                      <v-flex>
                        <v-checkbox
                          label="Available for Free User"
                          v-model="activity.isGuestPlayable"
                          :value="activity.isGuestPlayable"
                          v-on:change="
                            e => onChangeActivityData('isGuestPlayable', e)
                          "
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Title"
                          :value="activity.title"
                          v-on:change="e => onChangeActivityData('title', e)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Icon"
                          :value="
                            storyStore.updateActivity.icon || activity.icon
                          "
                          v-on:change="e => onChangeActivityData('icon', e)"
                        />
                        <v-btn
                          dark
                          color="black"
                          v-on:click="
                            isEditImage = true;
                            isEditActivity = true;
                          "
                        >
                          <v-icon>edit</v-icon>EDIT ICON
                        </v-btn>
                        <v-img
                          :src="storyStore.updateActivity.icon || activity.icon"
                          class="content_img"
                        ></v-img>
                      </v-flex>
                      <v-flex>
                        <v-select
                          :items="transition"
                          label="Transition"
                          :value="activity.transition"
                          v-model="activity.transition"
                          v-on:change="
                            e => onChangeActivityData('transition', e)
                          "
                        ></v-select>
                      </v-flex>
                      <v-flex>
                        <v-checkbox
                          label="Skip"
                          v-model="activity.skip"
                          :value="activity.skip"
                          v-on:change="e => onChangeActivityData('skip', e)"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex
                        v-for="(data, index) in activity.game_data"
                        :key="index"
                      >
                        <container>
                          <v-layout column>
                            <v-card-actions>
                              <label>
                                <b>🎯 GAME {{ index + 1 }}:</b>
                              </label>
                              <v-spacer></v-spacer
                              ><v-btn
                                v-if="
                                  activity.game_data.length > 1 && index > 0
                                "
                                icon
                                color="blue"
                                dark
                                @click="onMoveUp(index)"
                              >
                                <v-icon>keyboard_arrow_up</v-icon>
                              </v-btn>
                              <v-btn
                                v-if="
                                  activity.game_data.length > 1 &&
                                  index < activity.game_data.length - 1
                                "
                                icon
                                color="blue"
                                dark
                                @click="onMoveDown(index)"
                              >
                                <v-icon>keyboard_arrow_down</v-icon>
                              </v-btn>
                              <v-btn
                                v-if="activity.game_data.length > 1"
                                icon
                                color="red"
                                dark
                                @click="onDeleteGame(index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-card-actions>
                            <v-flex>
                              <v-select
                                :items="constants.GAME_TYPE"
                                label="Game Type"
                                :value="data.game_type"
                                v-model="data.game_type"
                                v-on:change="
                                  e => onChangeGameData('game_type', e, index)
                                "
                              ></v-select>
                            </v-flex>
                            <v-flex>
                              <v-select
                                :items="storyStore.gameType[data.game_type]"
                                label="Category"
                                :value="data.game_id"
                                v-model="data.game_id"
                                v-on:change="
                                  e => onChangeGameData('game_id', e, index)
                                "
                              ></v-select>
                            </v-flex>

                            <v-flex
                              v-if="
                                requiredSubIdList.indexOf(data.game_type) > -1
                              "
                            >
                              <container>
                                <v-layout
                                  column
                                  class="elevation-2"
                                  style="padding: 20px"
                                >
                                  <label>
                                    <u>⌗ Sub data</u>
                                  </label>
                                  <td
                                    v-for="(id, idx) in data.sub_id_list"
                                    :key="id"
                                  >
                                    <v-layout align-content-space-between>
                                      <v-select
                                        :items="subTitleList[index]"
                                        :value="data.sub_id_list[idx]"
                                        v-on:change="
                                          e =>
                                            onChangeSubTitleData(index, idx, e)
                                        "
                                      ></v-select>
                                      <v-btn
                                        icon
                                        dark
                                        color="black"
                                        v-clipboard:copy="id"
                                      >
                                        <v-icon>filter_none</v-icon>
                                      </v-btn>
                                    </v-layout>
                                  </td>
                                  <td
                                    v-if="
                                      selectedGameDataIndex == index &&
                                      newSubId == true
                                    "
                                  >
                                    <v-layout align-content-space-between>
                                      <v-select
                                        :items="subTitleList"
                                        :value="subTitleId"
                                        v-on:change="
                                          e =>
                                            onChangeSubTitleData(
                                              index,
                                              data.sub_id_list.length,
                                              e,
                                            )
                                        "
                                      ></v-select>
                                      <v-btn
                                        icon
                                        dark
                                        color="black"
                                        v-clipboard:copy="subTitleId"
                                      >
                                        <v-icon>filter_none</v-icon>
                                      </v-btn>
                                    </v-layout>
                                  </td>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      v-if="
                                        data.sub_id_list.length > 1 || newSubId
                                      "
                                      icon
                                      color="red"
                                      @click="onRemoveSubTitle(index)"
                                    >
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn v-else icon color="grey">
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="!newSubId"
                                      icon
                                      color="green"
                                      @click="onAddSubTitle(index)"
                                    >
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                    <v-btn v-else icon color="grey">
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                  </v-card-actions>
                                </v-layout>
                              </container>
                            </v-flex>

                            <v-flex
                              v-if="
                                requiredVideoData.indexOf(data.game_type) > -1
                              "
                            >
                              <container>
                                <v-layout
                                  column
                                  class="elevation-2"
                                  style="padding: 20px"
                                >
                                  <label>
                                    <u>⌗ Video data</u>
                                  </label>
                                  <v-flex
                                    v-for="(vdo, idx) in data.video_data"
                                    :key="idx"
                                    class="elevation-2"
                                    style="
                                      padding: 10px;
                                      margin-top: 5px;
                                      margin-bottom: 5px;
                                    "
                                  >
                                    <label>Video {{ idx + 1 }}:</label>
                                    <v-flex>
                                      <v-checkbox
                                        label="Is Loop?"
                                        v-model="vdo.isLoop"
                                        :value="vdo.isLoop"
                                        v-on:change="
                                          e =>
                                            onChangeVideoData(
                                              index,
                                              idx,
                                              'isLoop',
                                              e,
                                            )
                                        "
                                      ></v-checkbox>
                                    </v-flex>
                                    <v-flex>
                                      <v-text-field
                                        label="Video Link"
                                        :value="vdo.video_uri"
                                        v-on:change="
                                          e =>
                                            onChangeVideoData(
                                              index,
                                              idx,
                                              'video_uri',
                                              e,
                                            )
                                        "
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex>
                                      <v-text-field
                                        label="Next Index"
                                        :value="vdo.nextIndex"
                                        v-on:change="
                                          e =>
                                            onChangeVideoData(
                                              index,
                                              idx,
                                              'nextIndex',
                                              parseInt(e),
                                            )
                                        "
                                      ></v-text-field>
                                    </v-flex>
                                  </v-flex>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      v-if="
                                        data.video_data &&
                                        data.video_data.length > 1
                                      "
                                      icon
                                      color="red"
                                      @click="onRemoveVideoData(index)"
                                    >
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn v-else icon color="grey">
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                    <v-btn
                                      icon
                                      color="green"
                                      @click="onAddVideoData(index)"
                                    >
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                  </v-card-actions>
                                </v-layout>
                              </container>
                            </v-flex>
                          </v-layout>
                        </container>
                      </v-flex>

                      <v-btn
                        color="green"
                        @click="onAddMoreGame"
                        v-if="
                          requiredSubIdList.indexOf(
                            activity.game_data[0].game_type,
                          ) > -1
                        "
                      >
                        <v-icon>add</v-icon>Add More Game
                      </v-btn>
                      <v-flex>
                        <h2>Custom Configuration</h2>
                        <v-jsoneditor
                          class="editor"
                          :plus="false"
                          height="400px"
                          :options="editorOption"
                          :value="activity.config || {}"
                        />
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-btn
                        color="red"
                        @click="onClickDeleteActivity(activity._id)"
                        v-if="
                          storyStore.selectedStoryVideo.activities.length > 1
                        "
                      >
                        <v-icon>delete</v-icon>Delete this activity
                      </v-btn>
                    </v-card-actions>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-toolbar dark>
          <v-toolbar-title>Loading...</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card>
    </v-flex>
    <ResourceSelect
      v-if="isEditImage"
      resourceType="image"
      :isShow="isEditImage"
      :close="closeEditImage"
      :value="selectImageUri"
      :onSelect="onSelectImage"
      :save="onSaveResource"
    />
  </Container>
</template>
<style scoped>
/* .active {
  background-color: grey;
}
.inactive {
  background-color: white;
} */

.content_img {
  height: 200px;
  max-width: 100%;
  border-radius: 10px;
}

.editor {
  background-color: white;
  color: black;
}
</style>

<script>
import { mapActions, mapState } from 'vuex';
import swal from 'sweetalert2';
import draggable from 'vuedraggable';
import Container from '../../components/Container';
import ResourceSelect from '../../components/ResourceSelect';
import constants from '../../constants';
export default {
  name: 'StoryVideo',
  components: {
    Container,
    ResourceSelect,
    draggable,
  },
  data: function () {
    return {
      selectedActivityIndex: -1,
      selectedGameIndex: -1,
      selectActivityId: '',
      activities: [],
      activity: {},
      game_data: [],
      subTitleList: [],
      selectedGameDataIndex: -1,
      newSubId: false,
      subTitleId: '',
      isEditImage: false,
      isEditLevel: false,
      isEditActivity: false,
      selectImageUri: '',
      isDirty: false,
      constants,
      title: '',
      selectGameType: '',
      selectGameId: '',
      editorOption: {
        onChangeText: e => this.onChangeConfig(e),
        mode: 'code',
      },
      isAddActivity: false,
      requiredSubIdList: [
        'WWA',
        'ESL',
        'MC',
        'CN',
        'DD',
        'TTS',
        'MEDIA',
        'MM',
        'SW',
        'TR',
        'TB',
        'MPU',
        'CHR',
        'LB',
        'MNC',
      ],
      requiredVideoData: ['DD', 'TTS', 'MEDIA', 'MPU', 'TR', 'TB'],
      transition: [
        'LearningTime',
        'GameTime',
        'TalkTime',
        'StoryTime',
        'ReviewTime',
        'SongTime',
        'PhonicsTime',
      ],
    };
  },
  computed: {
    ...mapState({
      storyStore: state => state.storyvideo,
    }),
  },
  methods: {
    ...mapActions('storyvideo', [
      'fetchSingleStoryVideo',
      'updateActivityData',
      'updateActivity',
      'deleteActivity',
      'createActivityData',
      'createActivity',
      'updateLevelData',
      'updateLevel',
      'deleteLevel',
      'orderActivity',
      'clearUpdateActivityData',
      'clearUpdateLevelData',
      'fetchAllGameType',
    ]),
    order(e) {
      this.selectedActivityIndex = -1;
      this.orderActivity({
        currentIndex: e.oldIndex,
        newIndex: e.newIndex,
      });
    },
    onClickBack() {
      if (this.isDirty) {
        swal
          .fire({
            titleText: 'Unsaved modify. Are you sure you want to leave?',
            showCancelButton: true,
            type: 'info',
          })
          .then(result => {
            if (result.value) {
              this.clearUpdateLevelData();
              this.clearUpdateActivityData();
              this.$router.push('/storyvideos');
            }
          });
      } else {
        this.clearUpdateLevelData();
        this.clearUpdateActivityData();
        this.$router.push('/storyvideos');
      }
    },
    onSaveResource() {
      const uri = this.selectImageUri;
      if (this.isEditLevel) {
        this.updateLevelData({
          key: 'img_uri',
          value: uri,
        });
        this.isEditLevel = false;
      } else if (this.isEditActivity) {
        this.updateActivityData({
          key: 'icon',
          value: uri,
        });
        this.isEditActivity = false;
      }
      this.selectImageUri = '';
      this.isDirty = true;
      this.isEditImage = false;
    },
    closeEditImage() {
      this.selectImageUri = '';
      this.isEditImage = false;
    },
    onSelectImage(value) {
      this.selectImageUri = value;
    },
    onChangeLevel(key, value) {
      this.isDirty = true;
      if (key == 'isGuestPlayable') {
        value = value ? true : false;
      }
      this.updateLevelData({
        key,
        value,
      });
    },
    onClickUpdateLevel() {
      this.isDirty = false;
      this.selectedActivityIndex = -1;
      this.selectGameType = '';
      this.selectGameId = '';
      this.updateLevel();
    },
    onChangeSubTitleData(index, idx, value) {
      this.isDirty = true;
      if (this.selectedGameDataIndex == index && this.newSubId) {
        this.newSubId = false;
        this.selectedGameDataIndex = -1;
      }
      const game_data = [...this.activity.game_data];
      game_data[index].sub_id_list[idx] = value;
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
    },
    onAddSubTitle(index) {
      this.selectedGameDataIndex = index;
      this.newSubId = true;
      this.subTitleId = '';
    },
    onRemoveSubTitle(index) {
      if (this.newSubId) {
        this.newSubId = false;
        this.selectedGameDataIndex = -1;
      } else {
        this.isDirty = true;
        const game_data = [...this.activity.game_data];
        game_data[index].sub_id_list.pop();
        this.updateActivityData({
          key: 'game_data',
          value: game_data,
        });
      }
    },
    onChangeVideoData(index, idx, key, value) {
      this.isDirty = true;
      if (this.selectedGameDataIndex == index) {
        this.selectedGameDataIndex = -1;
      }
      const game_data = [...this.activity.game_data];
      if (key == 'isLoop' && !value) {
        value = false;
      }
      game_data[index].video_data[idx][key] = value;
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
    },
    onAddVideoData(index) {
      this.selectedGameDataIndex = index;
      const game_data = [...this.activity.game_data];
      game_data[index].video_data = game_data[index].video_data
        ? [...game_data[index].video_data, { ...this.storyStore.videoData }]
        : [{ ...this.storyStore.videoData }];
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
    },
    onRemoveVideoData(index) {
      this.isDirty = true;
      const game_data = [...this.activity.game_data];
      game_data[index].video_data.pop();
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
    },
    onAddMoreGame() {
      const new_game_data = { ...this.storyStore.gameData };
      const game_data = [...this.activity.game_data, new_game_data];
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
      this.activity.game_data = game_data;
    },
    onMoveUp(index) {
      const game_data = this.activity.game_data;
      game_data.splice(index - 1, 0, game_data.splice(index, 1)[0]);
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
      this.activity.game_data = game_data;
    },
    onMoveDown(index) {
      const game_data = this.activity.game_data;
      game_data.splice(index + 1, 0, game_data.splice(index, 1)[0]);
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
      this.activity.game_data = game_data;
    },
    onDeleteGame(index) {
      swal
        .fire({
          titleText: 'Delete Game ?',
          text: 'This operation cannot be undone. Would you like to proceed?',
          confirmButtonColor: 'red',
          confirmButtonText: 'Delete',
          showCancelButton: true,
          type: 'warning',
        })
        .then(async result => {
          if (result.value) {
            const game_data = this.activity.game_data;
            game_data.splice(index, 1);
            this.updateActivityData({
              key: 'game_data',
              value: game_data,
            });
            this.activity.game_data = game_data;
          }
        });
    },
    onChangeActivityData(key, value) {
      this.isDirty = true;
      if ((key == 'skip' || key == 'isGuestPlayable') && !value) {
        value = false;
      }
      this.updateActivityData({
        key,
        value,
      });
    },
    onChangeGameData(key, value, index) {
      this.isDirty = true;
      const game_data = [...this.activity.game_data];
      game_data[index][key] = value;
      this.updateActivityData({
        key: 'game_data',
        value: game_data,
      });
      if (key == 'game_id') {
        this.subTitleList[index] = this.getSubData(
          game_data[index].game_type,
          value,
        );
      }
    },
    onSelectActivity(index, id) {
      if (this.isDirty) {
        swal
          .fire({
            titleText: 'Unsaved modify. Are you sure you want to leave? ',
            showCancelButton: true,
            type: 'question',
          })
          .then(result => {
            if (result.value) {
              this.clearUpdateActivityData();
              this.selectedGameDataIndex = -1;
              this.selectedActivityIndex = index;
              this.selectActivityId = id;
              this.activity = {};
              this.isDirty = false;
              this.newSubId = false;
              this.activity = {
                ...this.storyStore.selectedStoryVideo.activities[index],
              };
              const game_data = [...this.activity.game_data];
              Object.keys(game_data).forEach(index => {
                this.subTitleList[index] = this.getSubData(
                  game_data[index].game_type,
                  game_data[index].game_id,
                  game_data[index].sub_id_list,
                );
              });
              this.game_data = game_data;
              this.storyStore.updateActivity = this.activity;
              this.updateActivityData({
                key: 'id',
                value: id,
              });
            }
          });
      } else {
        this.clearUpdateActivityData();
        this.selectedGameDataIndex = -1;
        this.selectedActivityIndex = index;
        this.selectActivityId = id;
        this.activity = {};
        this.isDirty = false;
        this.newSubId = false;
        this.activity = {
          ...this.storyStore.selectedStoryVideo.activities[index],
        };
        const game_data = [...this.activity.game_data];
        Object.keys(game_data).forEach(index => {
          this.subTitleList[index] = this.getSubData(
            game_data[index].game_type,
            game_data[index].game_id,
            game_data[index].sub_id_list,
          );
        });
        this.game_data = game_data;
        this.storyStore.updateActivity = this.activity;
        this.updateActivityData({
          key: 'id',
          value: id,
        });
      }
    },
    getSubData(game_type, game_id, sub_id_list) {
      if (this.requiredSubIdList.indexOf(game_type) < 0) {
        return;
      }

      const games = this.storyStore.gameType[game_type];
      const index = games.findIndex(game => game.category_id === game_id);
      if (index == -1) {
        return;
      }

      if (game_type == 'ESL') {
        const subTitleList = this.storyStore.gameType[game_type][index].books;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'CN') {
        const subTitleList = this.storyStore.gameType[game_type][index].nodes;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'DD') {
        const subTitleList = this.storyStore.gameType[game_type][index].sets;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'CHR') {
        const subTitleList = this.storyStore.gameType[game_type][index].quests;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'MC' || game_type == 'MM' || game_type == 'SW') {
        const subTitleList = this.storyStore.gameType[game_type][index].decks;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'MPU') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].activities;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'MEDIA') {
        const subTitleList = this.storyStore.gameType[game_type][index].videos;
        return subTitleList.map(data => {
          return {
            text: data.title,
            value: data._id,
          };
        });
      } else if (game_type == 'TTS') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].object_sets;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'TR' || game_type == 'TB') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].blueprints;
        return subTitleList.map(data => {
          return {
            text: data.text,
            value: data._id,
          };
        });
      } else if (game_type == 'WWA') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].questions;
        return subTitleList.map(data => {
          return {
            text: data.question,
            value: data._id,
          };
        });
      } else if (game_type == 'LB') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].label_sets;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      } else if (game_type == 'MNC') {
        const subTitleList =
          this.storyStore.gameType[game_type][index].minichats;
        return subTitleList.map(data => {
          return {
            text: data.name,
            value: data._id,
          };
        });
      }
    },
    onChangeConfig(e) {
      try {
        this.isDirty = true;
        if (this.isAddActivity) {
          this.createActivityData({
            key: 'config',
            value: JSON.parse(e),
          });
        } else {
          this.updateActivityData({
            key: 'config',
            value: JSON.parse(e),
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    onCloseCreateActivity() {
      this.isAddActivity = false;
      this.isDirty = false;
    },
    onClickSaveCreateActivity() {
      const levelId = this.storyStore.selectedStoryVideo._id;
      this.createActivity(levelId);
      this.selectGameType = '';
      this.selectGameId = '';
      this.onCloseCreateActivity();
    },
    onClickCreateActivity() {
      const levelId = this.storyStore.selectedStoryVideo._id;
      this.createActivity(levelId);
    },
    onUpdateActivity() {
      this.isDirty = false;
      this.selectedActivityIndex = -1;
      this.updateActivity();
    },
    onClickDeleteActivity(id) {
      this.deleteActivity(id);
      this.selectedActivityIndex = -1;
      this.selectGameId = '';
      this.selectGameType = '';
    },
    onClickDeleteLevel() {
      this.deleteLevel(this.storyStore.selectedStoryVideo._id);
    },
  },
  mounted() {
    this.fetchAllGameType();
    this.fetchSingleStoryVideo(this.$route.query.id);
    this.updateLevelData({
      key: 'id',
      value: this.$route.query.id,
    });
  },
};
</script>
